/** Ehepartner: bidirectional partner link; UI matches ContactComboBox from generateInputField. */
// Survives when the Steuernummer row removes the host from the DOM on SPA nav
// before this init can find `existingHost` and abort.
let ehepartnerEditAbortController = null

function initEhepartnerContactField() {
  const contactEditing = document.querySelector('.ContactEditing')
  const personDiv = document.querySelector('#person')
  if (!contactEditing || !personDiv) {
    return false
  }

  const currentContactId =
    window.location.pathname.match(/\/edit-person\/(\d+)/)?.[1]
  if (!currentContactId) {
    return false
  }

  const existing = personDiv.querySelector(
    '[data-field-name="ehepartner_contact_id"]'
  )
  const existingHost =
    existing?.closest('[data-ehepartner-ui="host"]') ||
    existing?.closest('.sub-section-content-row')
  if (existingHost?._contactId === currentContactId) {
    return true
  }

  // Always abort the prior instance — including when the tax-row teardown
  // already removed the host so `existingHost` is null.
  ehepartnerEditAbortController?.abort()
  ehepartnerEditAbortController = null
  existingHost?._ehepartnerAbortController?.abort()

  if (existingHost) {
    if (existingHost.dataset.ehepartnerOwnRow === 'true') {
      existingHost.remove()
    } else {
      const emptyColumn = document.createElement('div')
      emptyColumn.className = 'sub-section-content-column'
      existingHost.replaceWith(emptyColumn)
    }
  }

  const taxField = personDiv.querySelector('[data-field-name="taxNumber"]')
  const taxRow = taxField?.closest('.sub-section-content-row')
  const emptyTaxColumn = taxRow
    ? Array.from(taxRow.children).find((el) => {
        if (el.contains(taxField)) return false
        return (
          el.classList?.contains('sub-section-content-column') &&
          !el.querySelector('input, select, .ant-select, [data-field-name]')
        )
      })
    : null

  const subSectionContent = personDiv.querySelector('.sub-section-content')
  const rows = subSectionContent?.querySelectorAll('.sub-section-content-row')
  const lastRow = rows?.[rows.length - 1]
  if (!emptyTaxColumn && !lastRow) {
    return false
  }

  let selectedContactName = null
  let lastSelectedPartnerId = ''

  const field = generateInputField({
    id: 'ehepartner_contact_id',
    fieldType: 'ContactComboBox',
    name: 'ehepartner_contact_id',
    label: 'Ehepartner',
    placeholder: 'Lade Kontakte...',
    options: [],
    value: '',
    isDisabled: true,
    withClearBtn: true,
  })
  field.classList.remove('ehv-element')
  field.dataset.fieldName = 'ehepartner_contact_id'
  field
    .querySelector('.ant-select')
    ?.setAttribute('data-field-name', 'ehepartner_contact_id')

  let row
  if (emptyTaxColumn) {
    // Place Ehepartner in the empty column next to Steuernummer.
    field.dataset.ehepartnerUi = 'host'
    field.dataset.impowerxContactExtra = 'true'
    field._contactId = currentContactId
    emptyTaxColumn.replaceWith(field)
    row = field
  } else {
    row = document.createElement('div')
    row.className = 'sub-section-content-row'
    row._contactId = currentContactId
    row.dataset.impowerxContactExtra = 'true'
    row.dataset.ehepartnerOwnRow = 'true'
    row.dataset.ehepartnerUi = 'host'
    row.innerHTML =
      '<div class="impowerx-ehepartner-combobox-container"></div><div class="sub-section-content-column"></div>'
    lastRow.insertAdjacentElement('afterend', row)
    row
      .querySelector('.impowerx-ehepartner-combobox-container')
      ?.replaceWith(field)
  }

  const clearWrap = field.querySelector('.impowerx-contact-combobox-clear')
  const clearBtn = field.querySelector('.impowerx-contact-combobox-clear-btn')
  row._ehepartnerClearWrap = clearWrap
  row._ehepartnerClearBtn = clearBtn
  if (clearBtn) {
    clearBtn.setAttribute('aria-label', 'Ehepartner entfernen')
  }

  const updateEhepartnerClearBtnVisibility = () => {
    const wrap = row._ehepartnerClearWrap
    if (!wrap) {
      return
    }
    wrap.style.display = String(lastSelectedPartnerId || '').trim()
      ? ''
      : 'none'
  }
  updateEhepartnerClearBtnVisibility()

  const contactSelect = field.querySelector('.contact-combobox .ant-select')
  const contactSearchInput = field.querySelector(
    '.contact-combobox .ant-select-selection-search-input'
  )
  const contactSelectionItem = field.querySelector(
    '.contact-combobox .ant-select-selection-item'
  )
  const contactDropdown = field.querySelector(
    '.contact-combobox .impowerx-select-dropdown'
  )
  const contactOptionsList = field.querySelector(
    '.contact-combobox .contact-combobox-list'
  )

  const escapeHtml = (value = '') =>
    String(value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;')

  const renderContactOptions = (options = []) => {
    if (!contactOptionsList) {
      return
    }
    if (!options.length) {
      contactOptionsList.innerHTML = `
          <div class="ant-select-item ant-select-item-option ant-select-item-option-disabled" title="Keine Kontakte gefunden">
            <div class="ant-select-item-option-content"><div class="select-menu-item">Keine Kontakte gefunden</div></div>
          </div>`
      return
    }
    contactOptionsList.innerHTML = options
      .map((option) => {
        const label = escapeHtml(option.label)
        const value = escapeHtml(option.value)
        return `<div class="ant-select-item ant-select-item-option contact-combobox-item" data-value="${value}" title="${label}">
            <div class="ant-select-item-option-content"><div class="select-menu-item">${label}</div></div>
          </div>`
      })
      .join('')
  }

  const hideContactDropdown = () => {
    contactDropdown?.classList.add('ant-select-dropdown-hidden')
    contactSearchInput.style.visibility = 'visible'
    if (selectedContactName) {
      contactSearchInput.value = selectedContactName
    }
    console.log({ onClose: selectedContactName })
  }
  const showContactDropdown = () => {
    console.log({ onOpen: selectedContactName })
    if (
      contactSelect?.classList.contains('ant-select-disabled') ||
      contactSelect?.classList.contains('read-only')
    ) {
      return
    }
    contactDropdown?.classList.remove('ant-select-dropdown-hidden')
    const previousValue =
      contactSelectionItem.textContent.trim() || selectedContactName
    contactSelectionItem.textContent = ''
    contactSelectionItem.setAttribute('title', '')
    contactSearchInput.value = ''
    contactSearchInput.placeholder = previousValue || 'Kontakt auswählen...'
    contactSearchInput.focus()
    contactSearchInput.style.visibility = 'visible'
    contactOptionsList
      ?.querySelectorAll('.contact-combobox-item')
      .forEach((opt) => {
        opt.style.display = ''
      })
  }

  contactSelect?.addEventListener('click', (event) => {
    event.stopPropagation()
    if (contactDropdown?.classList.contains('ant-select-dropdown-hidden')) {
      showContactDropdown()
    } else {
      hideContactDropdown()
    }
  })

  contactSearchInput?.addEventListener('input', () => {
    const query = contactSearchInput.value.toLowerCase().trim()
    contactOptionsList
      ?.querySelectorAll('.contact-combobox-item')
      .forEach((option) => {
        option.style.display = option.textContent.toLowerCase().includes(query)
          ? ''
          : 'none'
      })
  })

  const authHeaders = () => {
    const token = JSON.parse(localStorage.getItem('auth') || '{}').token
    return {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    }
  }

  const save = async (partnerId) => {
    const token = JSON.parse(localStorage.getItem('auth') || '{}').token
    if (!token) {
      return { ok: false }
    }
    try {
      const res = await fetch(
        `${baseApiUrl}/api/impowerX/contacts/ehepartner`,
        {
          method: 'POST',
          headers: authHeaders(),
          body: JSON.stringify({
            contactId: currentContactId,
            partnerId: partnerId || null,
          }),
        }
      )
      return { ok: res.ok }
    } catch {
      return { ok: false }
    }
  }

  const clearEhepartnerUi = () => {
    contactSelect.dataset.selectedValue = ''
    lastSelectedPartnerId = ''
    contactSelectionItem.textContent = ''
    contactSelectionItem.setAttribute('title', '')
    selectedContactName = null
    contactSearchInput.value = ''
    contactSearchInput.style.visibility = 'visible'
    contactSearchInput.placeholder = 'Kontakt auswählen...'
    hideContactDropdown()
  }

  row._ehepartnerClearBtn?.addEventListener('click', async (e) => {
    e.preventDefault()
    e.stopPropagation()
    const clearWrap = row._ehepartnerClearWrap
    const snapshot = {
      partnerId: lastSelectedPartnerId,
      label: contactSelectionItem.textContent.trim(),
      title: contactSelectionItem.getAttribute('title') || '',
      selectedValue: contactSelect.dataset.selectedValue,
      selectedContactName,
    }
    if (clearWrap) {
      clearWrap.style.display = 'none'
    }
    clearEhepartnerUi()
    const result = await save(null)
    if (!result?.ok) {
      alert('Fehler beim Entfernen des Ehepartners')
      lastSelectedPartnerId = snapshot.partnerId
      contactSelect.dataset.selectedValue = snapshot.selectedValue
      contactSelectionItem.textContent = snapshot.label
      contactSelectionItem.setAttribute(
        'title',
        snapshot.title || snapshot.label
      )
      selectedContactName = snapshot.selectedContactName
      updateEhepartnerClearBtnVisibility()
    }
  })

  contactOptionsList?.addEventListener('click', (event) => {
    const selectedOption = event.target.closest('.contact-combobox-item')
    if (!selectedOption) {
      return
    }
    const selectedLabel = selectedOption.textContent.trim()
    const selectedValue = selectedOption.getAttribute('data-value') || ''
    contactSelect.dataset.selectedValue = selectedValue
    lastSelectedPartnerId = selectedValue
    contactSelectionItem.textContent = selectedLabel
    selectedContactName = selectedLabel
    contactSelectionItem.setAttribute('title', selectedLabel)
    contactSearchInput.value = ''
    contactSearchInput.placeholder = ''
    hideContactDropdown()
    save(selectedValue || null).then((result) => {
      if (!result?.ok) {
        alert('Fehler beim Speichern des Ehepartners')
      }
    })
    updateEhepartnerClearBtnVisibility()
  })

  const abortController = new AbortController()
  row._ehepartnerAbortController = abortController
  ehepartnerEditAbortController = abortController
  document.addEventListener(
    'click',
    (event) => {
      if (!row.contains(event.target)) {
        hideContactDropdown()
      }
    },
    { signal: abortController.signal }
  )

  const setDisabled = (isDisabled) => {
    contactSelect?.setAttribute('disabled', String(isDisabled))
    contactSelect?.classList.toggle('ant-select-disabled', isDisabled)
    contactSelect?.classList.toggle('read-only', isDisabled)
    if (contactSearchInput) {
      contactSearchInput.disabled = isDisabled
    }
    const clearBtn = row._ehepartnerClearBtn
    if (clearBtn) {
      clearBtn.disabled = isDisabled
      clearBtn.style.cursor = isDisabled ? 'not-allowed' : 'pointer'
      clearBtn.style.opacity = isDisabled ? '0.35' : '1'
    }
    if (isDisabled) {
      contactDropdown?.classList.add('ant-select-dropdown-hidden')
    }
  }

  ;(async () => {
    let contactOptions = []
    try {
      const response = await fetch(
        `${baseApiUrl}/services/pmp-accounting/api/v1/contacts/search/type?&types=PERSON&size=10000`,
        { headers: authHeaders() }
      ).catch(() => ({}))
      if (!response.ok) return
      const data = await response.json()
      const contacts = Array.isArray(data?.content) ? data.content : []
      contactOptions = contacts
        .filter((c) => String(c?.id) !== String(currentContactId))
        .map((c) => {
          const fullName = `${c?.firstName || ''} ${c?.lastName || ''}`.trim()
          const label =
            c?.companyName || fullName || c?.name || `Kontakt ${c?.id || ''}`
          return { label, value: String(c.id) }
        })
    } catch (e) {
      console.error(e)
    }
    if (!document.body.contains(row)) {
      return
    }
    renderContactOptions(contactOptions)

    try {
      const token = JSON.parse(localStorage.getItem('auth') || '{}').token
      if (token) {
        const res = await fetch(
          `${baseApiUrl}/api/impowerX/contacts/ehepartner?contactId=${currentContactId}`,
          { headers: authHeaders() }
        )
        if (res.ok) {
          const { partnerId } = await res.json()
          const pid = partnerId ? String(partnerId) : ''
          const opt = contactOptions.find((o) => String(o.value) === pid)
          contactSelect.dataset.selectedValue = pid
          lastSelectedPartnerId = pid
          const display = pid ? opt?.label || `Kontakt ${pid}` : ''
          if (pid) {
            contactSelectionItem.textContent = display
            contactSelectionItem.setAttribute('title', display)
            contactSearchInput.placeholder = ''
            selectedContactName = display
          } else {
            contactSearchInput.style.visibility = 'visible'
            contactSearchInput.placeholder = 'Kontakt auswählen...'
          }
        }
      }
    } catch (e) {
      console.error(e)
    }
    setDisabled(false)
    contactSearchInput.placeholder = contactSelect?.dataset.selectedValue
      ? ''
      : 'Kontakt auswählen...'
    updateEhepartnerClearBtnVisibility()
  })()

  return true
}

function initEhepartnerViewSection() {
  const currentContactId = window.location.pathname.match(
    /\/persons\/view-person\/(\d+)/
  )?.[1]
  if (!currentContactId) {
    return false
  }

  const BasicInfoDataSection = document.querySelector(
    '.PersonData .basic-info.section'
  )
  if (!BasicInfoDataSection) {
    return false
  }

  const desiredEhepartnerViewAnchor = () => {
    // View order mirrors edit: … → Ehepartner → Datenschutzerklärung → Rollen
    const privacyBlock = BasicInfoDataSection.querySelector(
      '[data-impowerx-view-privacy-policy-signed="true"]'
    )
    if (privacyBlock) {
      return { type: 'before', node: privacyBlock }
    }
    const rolesBlock = BasicInfoDataSection.querySelector(
      '[data-impowerx-view-contact-roles="true"]'
    )
    if (rolesBlock) {
      return { type: 'before', node: rolesBlock }
    }
    return { type: 'append', node: BasicInfoDataSection }
  }

  const isEhepartnerViewInPlace = (block, anchor) => {
    if (anchor.type === 'before') {
      return block.nextElementSibling === anchor.node
    }
    return anchor.node.lastElementChild === block
  }

  const placeEhepartnerViewBlock = (block) => {
    const anchor = desiredEhepartnerViewAnchor()
    // Only move when order is wrong — needless insertAdjacentElement remounts
    // thrash the person-view MutationObserver with the privacy block.
    if (isEhepartnerViewInPlace(block, anchor)) return false
    if (anchor.type === 'before') {
      anchor.node.insertAdjacentElement('beforebegin', block)
    } else {
      anchor.node.appendChild(block)
    }
    return true
  }

  const existing = document.querySelector(
    '[data-impowerx-view-ehepartner="true"]'
  )
  if (existing) {
    if (
      existing._contactId === currentContactId &&
      document.body.contains(existing)
    ) {
      placeEhepartnerViewBlock(existing)
      return true
    }
    existing.remove()
  }

  const block = document.createElement('div')
  block.dataset.impowerxViewEhepartner = 'true'
  block._contactId = currentContactId
  block.innerHTML = `
        <div class="label">Ehepartner</div>
        <div class="value" data-field-name="ehepartnerViewValue">
            Lade...
        </div>
    `

  placeEhepartnerViewBlock(block)

  ;(async () => {
    const valueEl = block.querySelector(
      '[data-field-name="ehepartnerViewValue"]'
    )
    try {
      const token = JSON.parse(localStorage.getItem('auth') || '{}').token
      if (!token) {
        valueEl.textContent = 'Nicht verfügbar'
        return
      }
      const res = await fetch(
        `${baseApiUrl}/api/impowerX/contacts/ehepartner?contactId=${currentContactId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json',
          },
        }
      )
      if (
        !document.body.contains(block) ||
        block._contactId !== currentContactId
      ) {
        return
      }
      if (!res.ok) {
        valueEl.textContent = 'Fehler beim Laden'
        return
      }
      const { partnerId } = await res.json()
      if (!partnerId) {
        valueEl.textContent = '—'
        return
      }
      const contactsData = await getImpowerXData(
        `${baseApiUrl}/api/impowerX/contacts`
      ).catch(() => ({}))
      const contacts = Array.isArray(contactsData?.contacts)
        ? contactsData.contacts
        : []
      const p = contacts.find((c) => String(c?.id) === String(partnerId))
      const fullName = `${p?.firstName || ''} ${p?.lastName || ''}`.trim()
      valueEl.textContent =
        p?.companyName || fullName || (partnerId ? `Kontakt ${partnerId}` : '—')
    } catch (e) {
      if (document.body.contains(block)) {
        valueEl.textContent = 'Fehler beim Laden'
      }
    }
  })()

  return true
}
